import { backendbaseUrl } from "../Utils/baseUrl";
import { JSON_HEADERS, BLOB_CONFIG, MULTIPART_HEADERS } from "../Utils/apiHeaders";
import { apiDelete, apiGet, apiPost, apiPut } from "../Helpers/apiRequest.helper";
import { Clearer, ClearerRate, ClearerRateFilterMode, ClearerRateFormState, ClearerRateListResponse, ClearerRatePagination, ClearerRateSorting } from "../Types/ClearerRate.type";

const PAPER_APP_NAME_WITH_CLEARERS = "paper-app/clearer-rates";
const PAPER_APP_NAME_WITH_CLEARER = "paper-app/clearer-rate";
const PAPER_APP_NAME = "paper-app";
const PAGE_SIZE_ATTRIBUTE = "page_size";

// LIST CLEARER RATES
export const listClearerRatesAPI = (
    filterModes: ClearerRateFilterMode[],
    pagination: ClearerRatePagination,
    sorting: ClearerRateSorting[]
): Promise<ClearerRateListResponse | Error> => {
    let url = `${backendbaseUrl}/${PAPER_APP_NAME_WITH_CLEARERS}/?page=${pagination.pageIndex + 1
        }&${PAGE_SIZE_ATTRIBUTE}=${pagination.pageSize}`;

    if (filterModes.length > 0) {
        const queryParams = filterModes
            .map((e) => `fieldName_${e.id}=${String(e.value)}_${e.mode}`)
            .join("&");
        url += `&${queryParams}`;
    }

    if (sorting.length > 0) {
        const sortParams = `sortField_${sorting[0].id}=${sorting[0].desc ? "desc" : "asc"
            }`;
        url += `&${sortParams}`;
    }

    return apiGet<ClearerRateListResponse>(url);
};

// GET CLEARER RATE CONTRACTS
export const getClearerRateContractsAPI = (): Promise<any[] | Error> => {
    return apiGet<any[]>(`${backendbaseUrl}/${PAPER_APP_NAME}/clearer-rate-contracts/`);
};

// GET CLEARER RATE CLEARERS
export const getClearerRateClearersAPI = (): Promise<any[] | Error> => {
    return apiGet<any[]>(`${backendbaseUrl}/${PAPER_APP_NAME}/clearer-rate-clearers/`);
};

// CREATE CLEARER RATE
export const createClearerRateAPI = (clearerRate: ClearerRate): Promise<any | Error> => {
    return apiPost(`${backendbaseUrl}/${PAPER_APP_NAME_WITH_CLEARERS}/`, clearerRate);
};

// UPDATE CLEARER RATE
export const updateClearerRateAPI = (user: any): Promise<any | Error> => {
    if (!user || !user.id) {
        return Promise.resolve(new Error("Invalid object or missing ID"));
    }

    const payload: ClearerRateFormState = {
        contract_input: user.contract_id,
        apply_mode: user.apply_mode,
        clearer_house_fees: user.clearer_house_fees,
        ...(user.apply_mode === "generic" ? {} : { clearer: user.clearer_id }),
    };

    return apiPut(`${backendbaseUrl}/${PAPER_APP_NAME_WITH_CLEARERS}/${user.id}/`, payload);
};

// DELETE CLEARER RATE
export const deleteClearerRateAPI = (userId: string): Promise<void | Error> => {
    return apiDelete(`${backendbaseUrl}/${PAPER_APP_NAME_WITH_CLEARERS}/${userId}/`);
};

// BULK DELETE CLEARER RATES
export const bulkDeleteClearerRatesAPI = (ids: string[]): Promise<any | Error> => {
    return apiDelete(
        `${backendbaseUrl}/${PAPER_APP_NAME_WITH_CLEARER}/export-delete/`,
        {
            data: { ids },
            headers: JSON_HEADERS,
        }
    );
};

// EXPORT ALL CLEARER RATES
export const exportAllClearerRatesAPI = (): Promise<Blob | Error> => {
    return apiGet<Blob>(
        `${backendbaseUrl}/${PAPER_APP_NAME_WITH_CLEARER}/export-delete/`,
        BLOB_CONFIG
    );
};

// DOWNLOAD CLEARER RATE TEMPLATE
export const downloadClearerRateTemplateAPI = (): Promise<Blob | Error> => {
    return apiGet<Blob>(
        `${backendbaseUrl}/${PAPER_APP_NAME}/download-clearer-rate-template/`,
        BLOB_CONFIG
    );
};

// UPLOAD CLEARER RATE FILE
export const uploadClearerRateFileAPI = (file: File): Promise<any | Error> => {
    const formData = new FormData();
    formData.append("file", file);

    return apiPost(
        `${backendbaseUrl}/${PAPER_APP_NAME}/upload/clearer-rate/`,
        formData,
        {
            headers: MULTIPART_HEADERS,
        }
    );
};